import { WEEK } from '@library';

export const greaterThanTwoWeeks = (endDate: number): boolean => {
    const today = Math.floor(Date.now() / 1000);
    const twoWeeks = Math.floor((WEEK * 2) / 1000);
    return endDate - today > twoWeeks;
};
